export default __webpack_public_path__ + "static/media/moi.f78d371c.jpg";